import React from 'react';

import { Badge as AntBadge } from 'antd';
import { BadgeProps } from 'antd/lib/badge';

export interface IBadgeProps extends BadgeProps {}

/**
 * Small numerical value or status descriptor for UI elements.
 */
export const Badge: React.FC<IBadgeProps> = (props) => <AntBadge {...props} />;
